import { useSplitTreatments, useTreatments } from '@splitsoftware/splitio-react'
import {
  Attributes,
  TreatmentWithConfig,
} from '@splitsoftware/splitio-react/types/splitio/splitio'

/**
 * @deprecated
 *
 * user 'useWorkspaceFeatureFlag' or 'useMemberFeatureFlag'
 */
export const useTreatment = (
  featureName: string,
  attributes?: Attributes,
  key?: string,
): TreatmentWithConfig => {
  const treatments = useTreatments([featureName], attributes, key)

  return treatments[featureName] || { treatment: 'off', config: '' }
}

/**
 * @deprecated
 *
 * use 'useWorkspaceFeatureFlag'
 */
export const useIsOrgFeatureFlagOn = (
  flagName: string,
  attributes?: SplitIO.Attributes,
): boolean => {
  return useWorkspaceFeatureFlag(flagName, attributes)
}

export const useWorkspaceFeatureFlag = (
  flagName: string,
  attributes?: SplitIO.Attributes,
  workspaceKey?: string,
): boolean => {
  const { treatments, isReady } = useSplitTreatments({
    names: [flagName],
    attributes,
    splitKey: workspaceKey,
    trafficType: 'organization',
  })

  if (!isReady) return false

  return treatments[flagName]?.treatment === 'on'
}

export const useWorkspaceFeatureFlagWithStatus = (
  flagName: string,
  attributes?: SplitIO.Attributes,
  workspaceKey?: string,
): { isEnabled: boolean; isReady: boolean } => {
  const { treatments, isReady } = useSplitTreatments({
    names: [flagName],
    attributes,
    splitKey: workspaceKey,
    trafficType: 'organization',
  })

  return {
    isEnabled: isReady && treatments[flagName]?.treatment === 'on',
    isReady,
  }
}

export const useWorkspaceFeatureFlags = (
  flags: string[],
  attributes?: SplitIO.Attributes,
  workspaceKey?: string,
): Record<string, boolean> => {
  const { treatments, isReady } = useSplitTreatments({
    names: flags,
    attributes,
    splitKey: workspaceKey,
    trafficType: 'organization',
  })

  if (!isReady) return {}

  return flags.reduce(
    (acc, flag) => {
      acc[flag] = treatments[flag]?.treatment === 'on'
      return acc
    },
    {} as Record<string, boolean>,
  )
}

export const useMemberFeatureFlag = (
  flagName: string,
  attributes?: SplitIO.Attributes,
  memberKey?: string,
): boolean => {
  const { treatments, isReady } = useSplitTreatments({
    names: [flagName],
    attributes,
    splitKey: memberKey,
    trafficType: 'user',
  })

  if (!isReady) return false

  return treatments[flagName]?.treatment === 'on'
}
